module.exports = __webpack_public_path__ + "img/undplogo.55343594.jpg";